// extracted by mini-css-extract-plugin
module.exports = {"customize-bundle":"CustomizeBundle_customize-bundle__Mkap4"};